// extracted by mini-css-extract-plugin
module.exports = {"about-us":"sustainablity_about-us__17NFp","subHeader":"sustainablity_subHeader__JRHVZ","detail":"sustainablity_detail__1NrCm"};